(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/vikinglotto/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/vikinglotto/assets/javascripts/init.js');

'use strict';

svs.numbergames.game_app.app.start({
  Router: svs.vikinglotto.Router,
  product: svs.numbergames.productMapping.CONSTANTS.VIKINGLOTTO
});

 })(window);